var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"-Copy-22",
    transform: "translate(-1201.000000, -210.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1198.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,15.5504097 L3,18.0833912 C3,18.3166921 3.18330787,18.5 3.4166088,18.5 L5.94959033,18.5 C6.05790862,18.5 6.16622691,18.4583391 6.2412165,18.3750174 L15.3399528,9.28461325 L12.2153868,6.16004722 L3.12498264,15.2504513 C3.04166088,15.3337731 3,15.4337592 3,15.5504097 Z M17.7562838,6.86828218 C18.0812387,6.54332732 18.0812387,6.01840022 17.7562838,5.69344535 L15.8065546,3.74371615 C15.4815998,3.41876128 14.9566727,3.41876128 14.6317178,3.74371615 L13.1069296,5.26850437 L16.2314956,8.39307041 L17.7562838,6.86828218 Z",
    id: "Shape-Copy-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7ae5b28079bb1a7215f67131ddd144f3.svg";
export { ForwardRef as ReactComponent };